import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './global.scss';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
//import store from './components/redux_components/store'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
  </React.StrictMode>
);
